import React from 'react'
import PropTypes from 'prop-types'
import Sprite from 'icons/common.svg'
import SvgSprite from 'components/svg-sprite'

export default function CommonIcons ({ item, ...props }) {
  return (
    <SvgSprite sprite={Sprite} item={item} {...props} />
  )
}

CommonIcons.propTypes = {
  item: PropTypes.string.isRequired
}
